var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 79,
    viewBox: "0 0 91 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4594 21.6435C51.2635 21.6435 55.9687 16.9383 55.9687 11.1342C55.9687 5.33015 51.2635 0.625 45.4594 0.625C39.6553 0.625 34.9502 5.33015 34.9502 11.1342C34.9502 16.9383 39.6553 21.6435 45.4594 21.6435Z",
    fill: "url(#paint0_linear_298_30655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2477 40.0473L72.4531 38.0041C69.1161 37.3051 65.8215 38.8346 64.0797 41.5537C62.388 40.6847 60.5689 39.9354 58.6339 39.3135V33.4892C58.6378 29.0824 55.0303 25.4788 50.639 25.4788H40.6242C36.2096 25.4788 32.6177 29.0824 32.6177 33.4892V39.3443C30.702 39.9546 28.9022 40.7039 27.1989 41.5768C25.4571 38.846 22.1586 37.3051 18.8177 38.0041L9.01512 40.0473C4.71251 40.9472 1.92003 45.2151 2.81994 49.5331L5.28028 61.286C6.1725 65.5924 10.4441 68.3849 14.7507 67.485L17.852 66.8361C19.4046 69.1303 21.5521 71.2352 24.302 73.035C30.0297 76.7892 37.596 78.8594 45.6256 78.8594C57.9116 78.8594 68.4942 73.9195 73.3684 66.8245L76.52 67.485C80.8226 68.3809 85.0943 65.5924 85.9865 61.286L88.4506 49.5331C89.3466 45.2151 86.5541 40.9472 82.2477 40.0473ZM45.6217 74.8465C38.3683 74.8465 31.5706 73.0196 26.4995 69.6787C24.7614 68.5432 23.3208 67.2803 22.1661 65.9285L24.5414 65.4302C28.8517 64.5342 31.6442 60.2663 30.7443 55.956L28.5389 45.3888C29.825 44.6974 31.1769 44.091 32.6136 43.5735V45.5008C32.6136 49.9 36.2132 53.5036 40.62 53.5036H50.6349C55.0303 53.5036 58.6299 49.8962 58.6299 45.5008V43.4731C60.0937 43.9945 61.4686 44.5932 62.7433 45.2729L60.5069 55.96C59.6147 60.2703 62.4033 64.5381 66.7136 65.4341L69.112 65.9362C64.6396 71.2314 55.7911 74.8465 45.6217 74.8465Z",
    fill: "url(#paint1_linear_298_30655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1158 35.4589C85.9198 35.4589 90.625 30.7538 90.625 24.9497C90.625 19.1456 85.9198 14.4404 80.1158 14.4404C74.3117 14.4404 69.6065 19.1456 69.6065 24.9497C69.6065 30.7538 74.3117 35.4589 80.1158 35.4589Z",
    fill: "url(#paint2_linear_298_30655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2905 35.2387C18.9758 34.0491 22.6064 28.4759 21.4322 22.7944C20.2348 17.1169 14.6731 13.4709 8.98396 14.6605C3.30642 15.8462 -0.339605 21.4156 0.850013 27.097C2.03587 32.7823 7.60527 36.4246 13.2905 35.2387Z",
    fill: "url(#paint3_linear_298_30655)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_30655",
    x1: 0.625,
    y1: 39.7422,
    x2: 90.6247,
    y2: 39.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_30655",
    x1: 0.625,
    y1: 39.7422,
    x2: 90.6247,
    y2: 39.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_30655",
    x1: 0.625,
    y1: 39.7422,
    x2: 90.6247,
    y2: 39.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_298_30655",
    x1: 0.625,
    y1: 39.7422,
    x2: 90.6247,
    y2: 39.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.7ffb6fac9d0781eac66a556618aa9075.svg";
export { ForwardRef as ReactComponent };